import play from "@/assets/img/find/play.png";
import "./CardNumberLessons.scss";
export const CardNumberLessons = () => {
  return (
    <div className="numberLessons">
      <img className="numberLessons__icon" src={play} alt="play"></img>
      <p className="numberLessons__text"> 20 Lessons</p>
    </div>
  );
};
